import {
  FC,
  RefObject,
  ReactElement,
  useEffect,
  useRef,
  useState,
} from 'react';
import classNames from 'classnames';
import { Swiper } from 'swiper/types';
import swiperCss from '@edikk-edikk/country-frontend/css/modules/swiper.module.scss';
import { useAdvertDetailContext } from '#advertDetail/hooks';
import { BtnNext, BtnPrev, Thumbnail } from '#advertDetail/components';
import galleryCss from '../../../assets/gallery/gallery.module.scss';
import galleryThumbnailsCss from '../../../assets/gallery/gallery-thumbnails.module.scss';

type PropsType = {
  refMainInstance: RefObject<Swiper>;
  activePhotoIndex: number;
};

const Thumbnails: FC<PropsType> = ({
  refMainInstance,
  activePhotoIndex,
}) => {
  const {
    advert: {
      photos,
    },
  } = useAdvertDetailContext();
  const slidesPerView = photos.length >= 3 ? 3 : 2;
  const refThumbsSwiper = useRef<HTMLDivElement>(null);
  const refThumbsInstance = useRef<Swiper>(null);
  const [progress, setProgress] = useState<number>(0);

  useEffect(() => {
    if (!refThumbsInstance.current) {
      return;
    }

    refThumbsInstance.current.slideTo(activePhotoIndex);
  }, [activePhotoIndex]);

  useEffect(() => {
    import('swiper').then(({ Swiper: SwiperInstance }) => {
      if (!refThumbsSwiper.current) {
        return;
      }

      refThumbsInstance.current = new SwiperInstance(refThumbsSwiper.current, {
        slidesPerView,
        allowTouchMove: false,
        on: {
          click: (swiper) => refMainInstance.current.slideTo(swiper.clickedIndex),
          progress: (swiper) => setProgress(swiper.progress),
        },
        wrapperClass: swiperCss.swiper__wrapper,
        slideClass: swiperCss.swiper__slide,
      });
    });
  }, [refMainInstance, slidesPerView]);

  const renderList = (): ReactElement[] => photos.map((photo, index) => (
    <Thumbnail key={photo.id} photo={photo} index={index} isActive={index === activePhotoIndex} />
  ));

  return (
    <div
      className={classNames(
        galleryCss.gallery__thumbs,
        galleryThumbnailsCss.galleryThumbs,
      )}
    >
      <BtnPrev
        isVisible={photos.length > slidesPerView && progress > 0}
        setProgress={setProgress}
        refThumbsInstance={refThumbsInstance}
      />
      <div className={galleryThumbnailsCss.galleryThumbs__swipper} ref={refThumbsSwiper}>
        <div className={classNames(swiperCss.swiper__wrapper, galleryThumbnailsCss.galleryThumbs__swipperWrapper)}>
          {renderList()}
        </div>
      </div>
      <BtnNext
        isVisible={photos.length > slidesPerView && progress < 1}
        setProgress={setProgress}
        refThumbsInstance={refThumbsInstance}
      />
    </div>
  );
};

export { Thumbnails };
